import "core-js/modules/es6.function.name";
import YKCarNumberSelectComponent from "./index.vue";
var YKCarNumberSelect = {
  install: function install(Vue) {
    Vue.component(YKCarNumberSelectComponent.name, YKCarNumberSelectComponent);
  },
  key: YKCarNumberSelectComponent.name
};
export default YKCarNumberSelect;